import { DropdownItemProps } from 'semantic-ui-react';

export interface Dictionary<T> {
  [key: string]: T;
}

export interface UserInfo {
  userEmail: string;
  userType: string;
  userName: string;
  claims: string[];
}

export enum Claims {
  ExternalApprover = 'ExternalApprover',
}

export interface NavigationDataProps {
  filters: NavigationItemDto[];
  filterNames: string[];
}

export type NavigationResultDto = {
  items: NavigationItemDto[];
};

export type NavigationItemDto = {
  id?: string;
  name: string;
  filters: string[];
  items: NavigationItemDto[];
};

export type UserInfoResultDto = {
  claims: string[];
  userType: string;
};

export type ClientProfileDto = {
  id: string;
  client: string;
  headerLogoStorageName?: string;
  footerLogoStorageName?: string;
  headerImageStorageName?: string;
  footerImageStorageName?: string;
  createdBy: string;
  createdAt: string;
  updatedBy: string;
  updatedAt: string;
};

export interface UpdateClientProfileDto {
  id: string;
  headerLogo?: UpdateFileDto;
  footerLogo?: UpdateFileDto;
  headerImage?: UpdateFileDto;
  footerImage?: UpdateFileDto;
}

export type CreateClientProfileDto = {
  client: string;
  headerLogo?: File;
  footerLogo?: File;
  headerImage?: File;
  footerImage?: File;
};

export type UpdateFileDto = {
  removed: boolean;
  file?: File;
};

export interface NotificationFeed {
  hasNotifications: boolean;
  notifications: TimedNotificationFeed[];
}

export interface TimedNotificationFeed {
  sectionHeader: string;
  notifications: Array<Notification>;
}

/// SignalR doesn't serialize with camelCase, but with PascalCase, so we need a copy
export interface SignalRNotification {
  Id: string;
  Title: string;
  Message: string;
  Context: Dictionary<string>;
  Read: boolean;
  CreatedAt: Date;
}

export interface Notification {
  id: string;
  title: string;
  message: string;
  context: Dictionary<string>;
  read: boolean;
  createdAt: Date;
}

export interface FaqDto {
  title: string;
  module: string;
  questions: Array<FrequentQuestion>;
}

export interface FrequentQuestion {
  question: string;
  answer: string;
}

export interface Vocabulary {
  word: string;
  meaning: string;
}
export interface GlossaryData {
  alphabet: string;
  vocabulary: Array<Vocabulary>;
}
export interface LoginPageImages {
  splashScreenBackgroundImage: string;
  splashScreenLogo: string;
  desktopViewBackgroundImage: string;
  desktopViewLogo: string;
  mobileViewBackgroundImage: string;
  isClientLogin: boolean;
}

export interface FilterDropdownItemProps extends DropdownItemProps {
  id?: string;
}

export interface IdNamePair {
  id: string | null;
  name: string;
}

export interface FiltersResult {
  data: IdNamePair[];
  selectedOptions: string[];
}

export interface ModuleUriParams {
  module: string;
}

export interface Dimensions {
  width: number;
  height: number;
}

export interface ImageFileConstraints {
  name: string;
  imageDimensions: Dimensions;
  imageDimensionsConstraint: string;
  maxFileSize: number;
  fileSizeConstraint: string;
  acceptedFileTypes: Dictionary<string[]>;
  fileTypesConstraint: string;
}
